import React, { useState } from "react";
import { TabContext } from "./tabContext";

function useActiveTabManagement(startingTab, controlledSetActiveTabId, controlledActiveTabId) {
  const [uncontrolledActiveTabId, setUncontrolledActiveTabId] = useState(startingTab);
  const isControlled = !!controlledSetActiveTabId;

  const activeTabId = isControlled ? controlledActiveTabId : uncontrolledActiveTabId;
  const setActiveTabId = isControlled ? controlledSetActiveTabId : setUncontrolledActiveTabId;

  return [activeTabId, setActiveTabId];
}

export const TabProvider = ({ children, startingTab = "", activeTabId: controlledActiveTabId, setActiveTabId: controlledSetActiveTabId }) => {
  const [tabList, setTabList] = useState([]);
  const [activeTabId, setActiveTabId] = useActiveTabManagement(startingTab, controlledSetActiveTabId, controlledActiveTabId);
  const registerTab = (tabTitle, tabId) => {
    setTabList(prevState => [...prevState, { tabTitle, tabId }]);
  };

  return (
    <TabContext.Provider value={{ registerTab, tabList, activeTabId, setActiveTabId }}>
      {children}
    </TabContext.Provider>
  );
}